let counter = 0;

export const nextId = () => counter++;

export default nextId;
